export default {
  cta: {
    id: 'rm_take_action_cta',
    defaultMessage: 'Take Action',
  },
} as const
